// import {store} from "../store/store";
import {Dispatch, isRejectedWithValue, MiddlewareAPI, UnknownAction} from "@reduxjs/toolkit";
// import {accessDeniedToast} from "../slices/toastSlice";

export const rtkQueryNotifications = (_api: MiddlewareAPI) => (next: Dispatch<UnknownAction>) => (action: UnknownAction) => {

    if (!['api/executeQuery/rejected', 'api/executeMutation/rejected'].includes(action.type)) {
        return next(action)
    }

    if (isRejectedWithValue(action)) {
        if (process.env.NODE_ENV === 'development') {
            console.log((action.payload as any).originalStatus)
        }
        if ((action.payload as any).originalStatus === 403) {
            // store.dispatch(accessDeniedToast())
        }
        // //todo add array of actions if they should be excluded from 5XX errors
        // if (![401, 404].includes(action.payload.originalStatus)) {
        //     store.dispatch(errorAlert());
        // }
    }

    return next(action)
}
